import React from "react";

const TextInput = ({
  label,
  id,
  name,
  value,
  onChange,
  error,
  required = false,
}) => {
  return (
    <div className="mt-2 w-100">
      <div className="sort_search_header_field">
        {label} {required && "*"}
      </div>
      <input
        className="text-input-modal"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
      />
      {error && (
        <div id={`${id}-error`} className="errorStyles">
          {error}
        </div>
      )}
    </div>
  );
};

export default TextInput;
